import { fork } from 'redux-saga/effects';
import * as projectSagas from './projects/saga.projects';
import * as userSagas from './user/saga.user';
import * as errorsSaga from './errors/saga.errors';
import * as scriptEditorSaga from './scriptEditor/saga.scriptEditor';
import * as btnOptionsSaga from './btnOptions/saga.btnOptions';
import * as diffModeSaga from './diffMode/saga.diffMode';
import * as testModeSaga from './testMode/saga.testMode';
import * as unloadPageSaga from './unloadPage/saga.unloadPage';
import * as mobileSpecificBehaviourSaga from './mobileSpecificBehaviour/saga.mobileSpecificBehaviour';
import * as analyticsSaga from './analytics/saga.analytics';
import * as configSaga from './config/saga.config';
import * as codeMetaDataSaga from './codeMetaData/saga.codeMetaData';
import * as gitHubIntegrationSaga from './gitHubIntegration/saga.gitHubIntegration';
import * as projectAnalyticsSaga from './projectAnalytics/saga.projectAnalytics';
import * as predefinedScriptsSaga from './predefinedScripts/saga.predefinedScripts';
import * as microphoneSaga from './microphone/saga.microphone';
import * as clientCodeRunnerSaga from './clientCodeRunner/saga.clientCodeRunner';
import * as organizationSaga from './organization/saga.organization';
import * as corpusSaga from './corpus/saga.corpus';

export default function* start() {
    yield fork(codeMetaDataSaga.watch);
    yield fork(userSagas.watch);
    yield fork(projectSagas.watch);
    yield fork(scriptEditorSaga.watch);
    yield fork(btnOptionsSaga.watch);
    yield fork(diffModeSaga.watch);
    yield fork(testModeSaga.watch);
    yield fork(unloadPageSaga.watch);
    yield fork(mobileSpecificBehaviourSaga.watch);
    yield fork(analyticsSaga.watch);
    yield fork(configSaga.watch);
    yield fork(gitHubIntegrationSaga.watch);
    yield fork(projectAnalyticsSaga.watch);
    yield fork(predefinedScriptsSaga.watch);
    yield fork(microphoneSaga.watch);
    yield fork(clientCodeRunnerSaga.watch);
    yield fork(organizationSaga.watch);
    yield fork(corpusSaga.watch);
    yield fork(errorsSaga.watchErrors);
}
